import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Wallet, Star } from "lucide-react";
import { VegDot, EmptyState, SkelCard } from "@/components/common";
import { api, inr } from "@/lib/api";

export default function ValueEats() {
  const nav = useNavigate();
  const [tiers, setTiers] = useState(null);

  useEffect(() => {
    api.get("/value-eats").then((r) => setTiers(r.data.tiers)).catch(() => setTiers([]));
  }, []);

  return (
    <div className="min-h-screen bg-surface max-w-[520px] mx-auto pb-24">
      <div className="sticky top-0 z-40 bg-gradient-to-br from-emerald-600 to-teal-700 text-white px-4 pt-3 pb-4 rounded-b-3xl">
        <div className="flex items-center gap-2">
          <button onClick={() => nav(-1)} className="w-9 h-9 flex items-center justify-center tap" data-testid="ve-back"><ArrowLeft size={22} /></button>
          <div className="flex items-center gap-2"><Wallet size={20} /><h1 className="font-display font-bold text-lg">Value Eats</h1></div>
        </div>
        <p className="text-xs text-white/80 mt-1 ml-11">Delicious food that's easy on the wallet</p>
      </div>

      <div className="px-4 py-4 space-y-7">
        {!tiers ? (
          <div className="grid gap-4">{[0, 1, 2].map((i) => <SkelCard key={i} />)}</div>
        ) : tiers.length === 0 ? (
          <EmptyState icon={Wallet} title="No value picks right now" subtitle="Check back soon for budget-friendly meals." testid="ve-empty" />
        ) : (
          tiers.map((t) => (
            <div key={t.key} data-testid={`ve-tier-${t.key}`}>
              <h2 className="font-display font-bold text-lg text-ink mb-3">{t.title}</h2>
              <div className="grid grid-cols-2 gap-3">
                {t.items.map((it) => (
                  <button key={it.id} onClick={() => nav(`/restaurant/${it.restaurant_id}`)} className="text-left bg-white rounded-2xl border border-border overflow-hidden tap" data-testid={`ve-item-${it.id}`}>
                    <img src={it.image} alt={it.name} loading="lazy" className="w-full h-24 object-cover" />
                    <div className="p-2.5">
                      <div className="flex items-center gap-1.5"><VegDot veg={it.veg} /><span className="font-bold text-sm text-ink truncate">{it.name}</span></div>
                      <div className="text-[11px] text-ink-600 truncate">{it.restaurant_name}</div>
                      <div className="flex items-center justify-between mt-1">
                        <span className="font-extrabold text-emerald-700">{inr(it.eff_price)}</span>
                        {it.rating && <span className="text-[11px] text-ink-600 flex items-center gap-0.5"><Star size={10} className="fill-gold text-gold" />{it.rating}</span>}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
